var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#B62A99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2904 6H7.20961C6.52308 6 6 6.52308 6 7.20962V13.2904C6 13.9769 6.52308 14.5 7.20961 14.5H13.2904C13.9769 14.5 14.5 13.9769 14.5 13.2904V7.20962C14.5 6.52308 13.9769 6 13.2904 6ZM10.25 12.8C11.6558 12.8 12.8 11.6885 12.8 10.3481C12.8 10.1192 12.7673 9.85769 12.7019 9.66154H13.4212V13.1269C13.4212 13.2904 13.2904 13.4538 13.0942 13.4538H7.40577C7.24231 13.4538 7.07885 13.3231 7.07885 13.1269V9.62885H7.83077C7.76539 9.85769 7.73269 10.0865 7.73269 10.3154C7.7 11.6885 8.84423 12.8 10.25 12.8ZM10.25 11.8192C9.33462 11.8192 8.61538 11.1 8.61538 10.2173C8.61538 9.33462 9.33462 8.61538 10.25 8.61538C11.1654 8.61538 11.8846 9.33462 11.8846 10.2173C11.8846 11.1327 11.1654 11.8192 10.25 11.8192ZM13.3885 8.32115C13.3885 8.51731 13.225 8.68077 13.0288 8.68077H12.1135C11.9173 8.68077 11.7538 8.51731 11.7538 8.32115V7.43846C11.7538 7.24231 11.9173 7.07885 12.1135 7.07885H13.0288C13.225 7.07885 13.3885 7.24231 13.3885 7.43846V8.32115Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.25,
    y1: 17.75,
    x2: 17.5,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEA054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502762,
    stopColor: "#D64763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62A99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.063665af.svg";
export { ForwardRef as ReactComponent };